<template>
    <div>
      <head-top :navActive="navActive"></head-top>
      <!-- banner start -->
      <div class="ts-index-banner" :style="{background:'url('+bannerImg+')'}">
        <div class="ts-index-banner-box">
          <h2>{{banner_title}}<br>
            {{text_line1}}</h2>
          <ul class="ts-index-banner-list">
            <li>
              <span></span>
              <p>{{text_line2}}
                <a href="https://cnkijc.cn/#/newsListDetail?Nid=55">[中国学术不端论文检测报告单样例]</a>
              </p>
            </li>
            <li>
              <span></span>
              <p>{{text_line3}}
                  <i class="decs-text" v-for="item in descriptionNav" :key="item.id"  @click="descriptionnavClickFun(item.id)">[{{item.name}}]</i>
              </p>
            </li>
            <li>
              <span></span>
              <p>{{text_line4}}</p>
            </li>
            <li>
              <span></span>
              <p>{{text_line5}}</p>
            </li>
          </ul>

          <div class="ts-banner-btn">
            <i><img src="../../static/img/ts-img/banner-icon.png" width="24"></i>
            <span><router-link :to="{ path:'/chSystem/'}">立即检测</router-link></span>
          </div>
        </div>
      </div>
      <!-- banner end -->
      <!-- 论文检测查重产品 start -->
      <div class="ts-index-wrapper">
        <div class="ts-index-main">
          <div class="title ts-title-blue">中国学术不端论文检测查重产品</div>
          <ul class="ts-product-list">
            <li v-for="item in goods_list">
              <div class="ts-product-list-div">
                <p class="ts-list-title">{{item.name}}</p>
                <p class="ts-product-price">{{item.price}}<span>元/篇</span></p>
                <p class="ts-product-cover-txt">{{item.desc}}</p>
                <a class="ts-product-cover-btn" @click="systemFun(item.id)">立即检测</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 论文检测查重产品 end -->
      <!-- 论文检测流程 start -->
      <div class="ts-index-wrapper ts-procedure-bg">
        <div class="ts-index-main">
          <div class="title ts-title-white">论文检测流程</div>
          <div class="ts-procedure-list">
            <div class="ts-procedure-list-top">
              <div class="ts-procedure-list-top-item"><i><img src="../../static/img/ts-img/procedure-icon1.png" width="40"></i></div>
              <div><img src="../../static/img/ts-img/procedure-icon6.png" width="68"></div>
              <div class="ts-procedure-list-top-item"><i><img src="../../static/img/ts-img/procedure-icon2.png" width="40"></i></div>
              <div><img src="../../static/img/ts-img/procedure-icon6.png" width="68"></div>
              <div class="ts-procedure-list-top-item"><i><img src="../../static/img/ts-img/procedure-icon3.png" width="40"></i></div>
              <div><img src="../../static/img/ts-img/procedure-icon6.png" width="68"></div>
              <div class="ts-procedure-list-top-item"><i><img src="../../static/img/ts-img/procedure-icon4.png" width="40"></i></div>
              <div><img src="../../static/img/ts-img/procedure-icon6.png" width="68"></div>
              <div class="ts-procedure-list-top-item"><i><img src="../../static/img/ts-img/procedure-icon5.png" width="40"></i></div>
            </div>
            <div class="ts-procedure-list-bot">
              <div class="ts-procedure-list-bot-item">
                <h3>01</h3>
                <p>选择查重系统</p>
              </div>
              <div class="ts-procedure-list-bot-item">
                <h3>02</h3>
                <p>上传论文</p>
              </div>
              <div class="ts-procedure-list-bot-item">
                <h3>03</h3>
                <p>担保交易付款</p>
              </div>
              <div class="ts-procedure-list-bot-item">
                <h3>04</h3>
                <p>下载论文查重报告</p>
              </div>
              <div class="ts-procedure-list-bot-item">
                <h3>05</h3>
                <p>确认评价</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 论文检测流程 end -->

      <!-- 论文查重系统 start -->
      <div class="ts-index-wrapper ts-index-system-bg">
        <div class="ts-index-main">
          <div class="title ts-title-blue" style="font-size: 24px;line-height: 40px;">一分钱一分货，毕业论文查重首选<br>"中国学术不端论文查重检测系统"</div>
          <ul class="ts-index-system-inner">
            <li class="ts-index-system-inner-item" v-for="(item,i) in systemData" :key="item.id">
              <div class="ts-index-system-inner-item-box">
                <span class="ts-top-line"></span>
                <div class="ts-index-system-inner-item-div">
                  <h3>0{{parseInt(i)+1}}</h3>
                  <p>{{item.title}}</p>
                </div>
                <span class="ts-bottom-line"></span>
              </div>
              <div class="ts-index-system-inner-hover-item">
                <div class="ts-index-system-inner-hover-item-box">
                  <span></span>
                  <p>{{item.desc}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 论文查重系统 end -->

      <!-- 降低重复率服务 start -->
      <div class="ts-index-wrapper ts-index-wrapper-bg2">
        <div class="ts-index-main">
          <div class="title ts-title-white">中国学术不端论文查重防骗攻略</div>
          <div class="ts-strategy">
            <div class="ts-strategy-item">
              <div class="ts-strategy-item-icon"><i class="ts-strategy-item-icon-1"></i></div>
              <h3 class="ts-strategy-item-title">中国学术不端查重杜绝假冒伪劣网址</h3>
              <p class="ts-strategy-item-txt">随着毕业季的来临，很多网站冒充中国学术不端提供查重服务。务必认准中国学术不端查重入口(www.cnkijc.cn)。防止财产损失。</p>
            </div>
            <div class="ts-strategy-item">
              <div class="ts-strategy-item-icon"><i class="ts-strategy-item-icon-2"></i></div>
              <h3 class="ts-strategy-item-title">支付和论文安全性</h3>
              <p class="ts-strategy-item-txt">支持微信扫码，支付宝担保交易。中国学术不端查重检测全程24小时自助。经中国学术不端查重授权，最大程度保护用户论文不外泄！</p>
            </div>
            <div class="ts-strategy-item">
              <div class="ts-strategy-item-icon"><i class="ts-strategy-item-icon-3"></i></div>
              <h3 class="ts-strategy-item-title">中国学术不端查重官方验证</h3>
              <p class="ts-strategy-item-txt">中国学术不端查重报告均支持官方验证，100%正品，所提供中国学术不端检测报告保证与学校结果一致的前提下，支持官网验证！</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 降低重复率服务 end -->

      <!-- 论文修改降低重复率服务 start -->
      <div class="ts-index-wrapper">
        <div class="ts-index-main">
          <div class="title ts-title-blue">论文修改降低重复率服务</div>
          <ul class="ts-index-service">
            <li>
              <div class="ts-index-service-icon"><i><img src="../../static/img/ts-img/service-icon1.png" width="50"></i></div>
              <h3 class="ts-index-service-title">服务宗旨</h3>
              <p class="ts-index-service-txt">6年论文重复率修改经验，不改变原文含义框架，将论文重复率降至5%以内！</p>
            </li>
            <li>
              <div class="ts-index-service-icon"><i><img src="../../static/img/ts-img/service-icon2.png" width="50"></i></div>
              <h3 class="ts-index-service-title">修改流程</h3>
              <p class="ts-index-service-txt">了解客户需求，确认目标重复率及稿件要求后，提供论文原文及中国学术不端论文检测报告，老师即刻开始修改。</p>
            </li>
            <li>
              <div class="ts-index-service-icon"><i><img src="../../static/img/ts-img/service-icon3.png" width="50"></i></div>
              <h3 class="ts-index-service-title">写手素质</h3>
              <p class="ts-index-service-txt">高校在职教师,专业211，985学霸团队，全专业修改老师。用心接待每位客户。</p>
            </li>
            <li>
              <div class="ts-index-service-icon"><i><img src="../../static/img/ts-img/service-icon4.png" width="50"></i></div>
              <h3 class="ts-index-service-title">交稿标准</h3>
              <p class="ts-index-service-txt">如约交稿。修改的论文送中国学术不端检测，客户确认重复率及论文稿件无误后。支付修改款项。</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 论文修改降低重复率服务 end -->

      <!-- 新闻资讯 start -->
      <div class="ts-index-wrapper ts-index-news-bg">
        <div class="ts-index-main">
          <div class="title ts-title-blue">新闻资讯</div>
          <ul class="ts-index-news-list">
            <li v-for="item in newListData" :key="item.id">
              <div class="ts-index-news-list-item-bg">
                <h3>{{item.name}}</h3>
                <p>{{item.english_name}}</p>
              </div>
              <div class="ts-index-news-list-inner">
                <div class="ts-index-news-list-inner-item" v-for="subItem in item.news_list" :key="subItem.id">
                  <p class="title">{{subItem.title}}</p>
                  <p class="data" @click="lookDetailFun(subItem.id)">
                    <span>{{subItem.created_at}}</span>
                    <a>【查看详细】</a>
                  </p>
                </div>

                <div class="ts-index-news-more">
                  <div>
                    <span @click="newLookMore(item.id)">查看更多</span>
                    <i><img src="../../static/img/ts-img/news-more-icon1.png" width="18"></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 新闻资讯 end -->

      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from '../assets/js/tool.js'
    export default {
        name: "index",
        data () {
          return {
            navActive: 0, //当前导航
            bannerImg: '', //banner图片
            logoImg: '', //顶部logo
            codeAddress: '', //二维码地址
            top_title: '', //顶部标题
            statement: '', //底部声明
            copyright: '', //版权信息
            company_address: '', //企业地址
            goods_list:'',//查重产品
            systemData: '', //一分钱一分货
            newListData: '', //新闻列表
            descriptionNav:'',
            banner_title:'',//头部标题
            text_line1:'',
            text_line2:'',
            text_line3:'',
            text_line4:'',
            text_line5:'',
          }
        },
        components: {
          headTop,
          footBottom
        },
        methods: {
          /* 查重系统简介 */
          descriptionNavFun () {
            let data = {
              parent_id : 11
            };
            tool.postData('get_category_two',data,(res) => {
              this.descriptionNav = res.data.data.category_list;
            });
          },
          descriptionnavClickFun (id) {
            if (id == 13) {
              this.$emit ('navClick', id);
              this.$router.push({
                path: '/descriptionThird/',
                query: {
                  id:id
                }
              })
            }else{
              this.$emit ('navClick', id);
              this.$router.push({
                path: '/descriptionFirst/',
                query: {
                  id:id
                }
              })
            }
          },
          /* 获取banner */
          getBanInfo () {
            let data = {
              type: 1,
              position: 1
            };
            tool.postData('get_banner',data,(res) => {
              this.bannerImg = res.data.data.banner_image;
              this.banner_title = res.data.data.banner_title;
              this.text_line1 = res.data.data.text_line1;
              this.text_line2 = res.data.data.text_line2;
              this.text_line3 = res.data.data.text_line3;
              this.text_line4 = res.data.data.text_line4;
              this.text_line5 = res.data.data.text_line5;
            });
          },
        //  获取查重产品
          getProInfo () {
            let data = {
            };
            tool.postData('get_goods_brief_list',data,(res) => {
              // this.bannerImg = res.data.data.banner_image;
              this.goods_list = res.data.data.goods_list;
              // console.log(res.data.data.goods_list)
            });
          },
          //  获取一分钱一分货
          getProSystem () {
            let data = {
              information_category_id: 3
            };
            tool.postData('get_information_list',data,(res) => {
              this.systemData = res.data.data.list;
            });
          },
          /* 立即检测 */
          systemFun (id) {
            this.$router.push({
              path: '/chSystemDetail/',
              query: {
                id: id
              }
            })
          },
          //新闻list
          getNewList () {
            let data = {};
            tool.postData('get_news_list',data,(res) => {
              this.newListData = res.data.data.news_category_list;
            });
          },
          /* 查看更多 */
          newLookMore (id) {
            this.$router.push({
              path: '/newsList/',
              query: {
                id: id
              }
            })
          },
          /* 查看详情 */
          lookDetailFun (id) {
            this.$router.push({
              path: '/newsListDetail/',
              query: {
                Nid: id
              }
            })
          },
        },
        mounted () {
          this.getBanInfo();
          this.getProInfo();
          this.getProSystem();
          this.getNewList();
          this.descriptionNavFun()
        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .ts-index-banner{
    width: 100%;
    background: url("../../static/img/ts-img/banner.png") no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    padding: 80px 0;
    .ts-index-banner-box{
      width: 1000px;
      margin: 0 auto;
      h2{
        @include font(36px,#fff);
        font-weight: bold;
        line-height: 50px;
      }
      .ts-index-banner-list{
        margin-top: 10px;
        .decs-text{
        }
        li{
          display: flex;
          align-items: center;
          margin-top: 14px;
          span{
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #fff;
          }
          p{
            @include font(15px,#fff);
            margin-left: 10px;
            a{
              color: #fff;
            }
            i{
              cursor: pointer;
            }
            i:nth-child(1){
              display: none;
            }
            i:nth-child(3){
              display: none;
            }
          }
        }
      }
      .ts-banner-btn{
        width: 175px;
        height: 46px;
        @include flex($content:center);
        border: 2px solid #fff;
        border-radius: 8px;
        margin-top: 35px;
        cursor: pointer;
        span{
          @include font(20px,#fff);
          margin-left: 10px;
          font-weight: bold;
          a{
            color: #fff;
          }
        }
      }
    }
  }

  .ts-index-main{
    width: 1237px;
    margin: 0 auto;
    padding: 73px 0;
    .title{
      width: 670px;
      text-align: center;
      line-height: 58px;
      margin: 0 auto;
    }
    .ts-title-blue{
      background: url("../../static/img/ts-img/blue-title-bg.png") no-repeat center center;
      @include font(34px,#333);
    }
    .ts-title-white{
      background: url("../../static/img/ts-img/white-title-bg.png") no-repeat center center;
      @include font(34px,#fff);
    }
    .ts-product-list{
      display: flex;
      justify-content: space-around;
      margin-top: 45px;
      li{
        width: 232px;
        height: 310px;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        border: 1px solid;
        .ts-product-list-div{
          height: 300px;
          .ts-product-list-icon{
            width: 58px;
            height: 71px;
            display: block;
            margin: 0 auto;
          }
          .ts-list-title{
            @include font(18px,#fff);
            text-align: center;
            font-weight: 700;
            line-height: 47px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .ts-product-price{
            @include font(36px,#3b6bda);
            margin-top: 33px;
            margin-bottom: 10px;
            text-align: center;
            font-weight: bold;
            span{
              font-size: 16px;
              margin-left: 5px;
            }
          }
          .ts-product-cover-txt{
            width: 185px;
            height: 120px;
            margin: 0 auto;
            line-height:20px;
          }
          .ts-product-cover-btn{
            width: 148px;
            line-height: 37px;
            text-align: center;
            @include  font(16px,#fff);
            margin: 0 auto;
            border-radius: 5px;
            display: block;
            cursor: pointer;
          }
        }
        &:nth-child(n){
          border: 1px solid #3b6bda;
          .ts-list-title{
            background-color: #3b6bda;
          }
          .ts-product-cover-btn{
            background-color: #3b6bda;
          }
          .ts-product-cover-btn:hover{
            background-color:#1647b9;
          }
          .ts-product-price{
            color: #3b6bda;
          }
        }
        &:nth-child(n):hover{
          box-shadow: 0 2px 10px 2px #8fb3ff;
        }
        &:nth-child(2n):hover{
          box-shadow: 0 2px 10px 2px #fcc29f;
        }
        &:nth-child(2n){
          border: 1px solid #eb8c52;
          .ts-list-title{
            background-color: #eb8c52;
          }
          .ts-product-cover-btn{
            background-color: #eb8c52;
          }
          .ts-product-cover-btn:hover{
            background-color:#e0402b;
          }
          .ts-product-price{
            color: #eb8c52;
          }
        }
        /*.ts-product-cover{
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,.7);
          opacity: 0;
          transform: rotateY(180deg);
          transition:all 1.5s;
          .ts-product-cover-box{
            width: 85%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            .ts-product-cover-txt{
              @include font(16px,#fff);
              line-height: 23px;
            }
            .ts-product-cover-btn{
              width: 150px;
              line-height: 35px;
              display: block;
              margin: 20px auto 0;
              @include font(16px,#3b6bda);
              text-align: center;
              background-color: #fff;
              border-radius: 5px;
              cursor: pointer;
            }
          }
        }*/
      }
    }
  }

  .ts-procedure-bg{
    width: 100%;
    height: 550px;
    background: url("../../static/img/ts-img/index-bg1.png") no-repeat;
    background-size: 100% 100%;
  }
  .ts-procedure-list{
    margin-top: 85px;
    .ts-procedure-list-top{
      @include flex($content:space-around);
      .ts-procedure-list-top-item{
        width: 135px;
        height: 135px;
        border-radius: 50%;
        border: 1px solid #fff;
        @include flex($content:center);
        cursor: pointer;
        i{
          width: 115px;
          height: 115px;
          @include flex($content:space-around);
          border-radius: 50%;
        }
        &:hover{
          width: 137px;
          height: 137px;
          background-color:rgba(59,107,218,.4);
          border: none;
          i{
            background-color: #3b6bda;
          }
        }
      }
    }
    .ts-procedure-list-bot{
      display: flex;
      margin-top: 20px;
      .ts-procedure-list-bot-item{
        width: 150px;
        margin-right: 123px;
        text-align: center;
        h3{
          @include font(24px,#fff);
          line-height: 40px;
          font-weight: 700;
        }
        p{
          @include font(16px,#fff);
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  .ts-index-system-bg{
    width: 100%;
    height: 686px;
    background: url("../../static/img/ts-img/bg1.png") no-repeat center center;
    background-size: cover;
    .ts-index-system-inner{
      @include flex;
      .ts-index-system-inner-item{
        flex: 1;
        height: 399px;
        position: relative;
        cursor: pointer;
        .ts-index-system-inner-item-box{
          margin-top: 99px;
          .ts-top-line{
            width: 57px;
            height: 10px;
            position: absolute;
            top: 65px;
            right: 0;
            background-color: #000;
          }
          .ts-bottom-line{
            width: 57px;
            height: 10px;
            position: absolute;
            bottom: 65px;
            left: 0;
            background-color: #000;
          }
          .ts-index-system-inner-item-div{
            h3{
              font-size: 100px;
            }
            p{
              font-size: 24px;
              margin-top: 50px;
            }
          }
        }
        .ts-index-system-inner-hover-item{
          position: absolute;
          top: 35px;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #fff;
          border: 1px solid transparent;
          border-radius: 7px;
          display: flex;
          opacity: 0;
          align-items: center;
          justify-content: center;
          transition: all .7s;
          .ts-index-system-inner-hover-item-box{
            width: 90%;
            span{
              width: 50px;
              height: 4px;
              background-color: #000;
              display: block;
            }
            p{
              @include font(16px,#666);
              line-height: 30px;
              max-height: 399px;
              overflow: auto;
              &::-webkit-scrollbar {display:none}
            }
          }
        }
        &:nth-child(1){
          .ts-index-system-inner-item-box{
            .ts-top-line{
              background-color: #3b6bda;
            }
            .ts-bottom-line{
              background-color: #3b6bda;
            }
            .ts-index-system-inner-item-div{
              h3{
                color: #89a6e9;
              }
              p{
                color: #3b6bda;
              }
            }
          }
          .ts-index-system-inner-hover-item{
            border-color: #3b6bda;
            box-shadow: 0 2px 4px 2px #89a6e9;
            .ts-index-system-inner-hover-item-box{
              span{
                background-color: #3b6bda;
              }
            }
          }
        }
        &:nth-child(2){
          .ts-index-system-inner-item-box{
            .ts-top-line{
              background-color: #e04c5b;
            }
            .ts-bottom-line{
              background-color: #e04c5b;
            }
            .ts-index-system-inner-item-div{
              h3{
                color: #ec949d;
              }
              p{
                color: #e04c5b;
              }
            }
          }
          .ts-index-system-inner-hover-item{
            border-color: #e04c5b;
            box-shadow: 0 2px 4px 2px #ec949d;
            .ts-index-system-inner-hover-item-box{
              span{
                background-color: #e04c5b;
              }
            }
          }
        }
        &:nth-child(3){
          .ts-index-system-inner-item-box{
            .ts-top-line{
              background-color: #46c79d;
            }
            .ts-bottom-line{
              background-color: #46c79d;
            }
            .ts-index-system-inner-item-div{
              h3{
                color: #90ddc4;
              }
              p{
                color: #46c79d;
              }
            }
          }
          .ts-index-system-inner-hover-item{
            border-color: #83dec0;
            box-shadow: 0 2px 4px 2px #cef0e5;
            .ts-index-system-inner-hover-item-box{
              span{
                background-color: #46c79d;
              }
            }
          }
        }
        &:nth-child(4){
          .ts-index-system-inner-item-box{
            .ts-top-line{
              background-color: #eb8c52;
            }
            .ts-bottom-line{
              background-color: #eb8c52;
            }
            .ts-index-system-inner-item-div{
              h3{
                color: #f1b997;
              }
              p{
                color: #eb8c52;
              }
            }
          }
          .ts-index-system-inner-hover-item{
            border-color: #eb8c52;
            box-shadow: 0 2px 4px 2px #f1b997;
            .ts-index-system-inner-hover-item-box{
              span{
                background-color: #eb8c52;
              }
            }
          }
        }
        &:hover{
          .ts-index-system-inner-hover-item{
            opacity: 1;
          }
        }
      }
    }
  }

  .ts-index-wrapper-bg2{
    width: 100%;
    height: 552px;
    background: url("../../static/img/ts-img/bg3.png") no-repeat 50%;
    background-size:100% 100%;
    .ts-strategy{
      display: flex;
      margin-top: 54px;
      justify-content: space-between;
      .ts-strategy-item{
        width: 324px;
        height: 302px;
        .ts-strategy-item-icon{
          width: 160px;
          height: 160px;
          border-radius: 50%;
          border: 2px solid #fff;
          @include flex($content:center);
          margin: 0 auto;
          .ts-strategy-item-icon-1{
            width: 61px;
            height: 73px;
            background: url("../../static/img/ts-img/strategy-icon1.png") no-repeat center center;
            background-size: 100%;
          }
          .ts-strategy-item-icon-2{
            width: 61px;
            height: 73px;
            background: url("../../static/img/ts-img/strategy-icon2.png") no-repeat center center;
            background-size: 100%;
          }
          .ts-strategy-item-icon-3{
            width: 61px;
            height: 73px;
            background: url("../../static/img/ts-img/strategy-icon3.png") no-repeat center center;
            background-size: 100%;
          }
          &:hover{
            background-color: #fff;
            .ts-strategy-item-icon-1{
              background: url("../../static/img/ts-img/strategy-icon1-hover.png") no-repeat center center;
            }
            .ts-strategy-item-icon-2{
              background: url("../../static/img/ts-img/strategy-icon2-hover.png") no-repeat center center;
            }
            .ts-strategy-item-icon-3{
              background: url("../../static/img/ts-img/strategy-icon3-hover.png") no-repeat center center;
            }
          }
        }
        .ts-strategy-item-title{
          @include font(20px,#fff);
          text-align: center;
          line-height: 80px;
        }
        .ts-strategy-item-txt{
          @include font(16px,#fff);
          text-align: center;
          line-height: 27px;
        }
      }
    }
  }

  .ts-index-service{
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    li{
      width: 215px;
      position: relative;
      .ts-index-service-icon{
        width: 121px;
        height: 139px;
        background: url("../../static/img/ts-img/service-bg.png") no-repeat center center;
        position: relative;
        margin: 0 auto;
        transform: rotate(0);
        transition: all .5s;
        i{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
        &:hover{
          transform: rotate(360deg);
        }
      }
      .ts-index-service-title{
        @include font(20px,#333);
        line-height: 55px;
        text-align: center;
      }
      .ts-index-service-txt{
        @include font(16px,#666);
        line-height: 24px;
        text-align: center;
      }
    }
  }

  .ts-index-news-bg{
    width: 100%;
    height: 670px;
    background: url("../../static/img/ts-img/bg4.png") no-repeat 50%;
    background-size:100% 100%;
    .ts-index-news-list{
      @include flex;
      margin-top: 60px;
      li{
        width: 287px;
        height: 394px;
        background-color: #fff;
        .ts-index-news-list-item-bg{
          width: 100%;
          height: 142px;
          padding: 40px 30px 0;
          box-sizing: border-box;
          h3{
            @include font(28px,#fff);
          }
          p{
            @include font(16px,#fff);
            margin-top: 13px;
          }
        }
        .ts-index-news-more{
          @include flex($content:flex-end);
          height: 30px;
          cursor: pointer;
        }
        &:nth-child(1){
          .ts-index-news-list-item-bg{
            background: url("../../static/img/ts-img/news-bg1.png") no-repeat;
          }
          .ts-index-news-list-inner{
            .ts-index-news-list-inner-item{
              .data{
                a{
                  color: #3b6bda;
                }
              }
            }
          }
        }
        &:nth-child(2){
          .ts-index-news-list-item-bg{
            background: url("../../static/img/ts-img/news-bg2.png") no-repeat;
          }
          .ts-index-news-list-inner{
            .ts-index-news-list-inner-item{
              .data{
                a{
                  color: #ea6371;
                }
              }
            }
          }
        }
        &:nth-child(3){
          .ts-index-news-list-item-bg{
            background: url("../../static/img/ts-img/news-bg3.png") no-repeat;
          }
          .ts-index-news-list-inner{
            .ts-index-news-list-inner-item{
              .data{
                a{
                  color: #46c79d;
                }
              }
            }
          }
        }
        &:nth-child(4){
          .ts-index-news-list-item-bg{
            background: url("../../static/img/ts-img/news-bg4.png") no-repeat;
          }
          .ts-index-news-list-inner{
            .ts-index-news-list-inner-item{
              .data{
                a{
                  color: #e88a51;
                }
              }
            }
          }
        }
        .ts-index-news-list-inner{
          background-color: #fff;
          padding: 10px;
          box-sizing: border-box;
          .ts-index-news-list-inner-item{
            cursor: pointer;
            .title{
              @include font(16px,#333);
              width: 100%;
              text-align: left;
              line-height: 35px;
              border-bottom: 1px solid #e5e5e5;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
            .data{
              width: 100%;
              @include flex;
              border-bottom: 1px solid #e5e5e5;
              display: none;
              span{
                @include font(16px,#999);
                line-height: 35px;
              }
              a{
                font-size: 16px;
                line-height: 35px;
              }
            }
            &:nth-child(1){
              .data{
                display: flex;
              }
            }
            &:hover{
              .data{
                display: flex;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue